﻿import React from 'react';
import PropTypes from 'prop-types';

import theme from "./ProductList.module.sass";

const productListDefaultPropProducts = [];
const ProductList = ({
  products = productListDefaultPropProducts
}) => (
  <ul className={theme.ProductList}>
    {products.map(({ name, quantity }, key) => (
      <li key={key}>{name} <span>x {quantity}</span></li>
    ))}
  </ul>
);

ProductList.propTypes = {
  products: PropTypes.array,
};

export default ProductList;
